<template>
  <div>
    <Head title="Поездки" />
    <h1 class="mb-8 text-3xl font-bold">Поездки</h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block text-gray-700">Статус:</label>
        <select v-model="form.status" class="form-select mt-1 w-full">
          <option :value="null" />
          <option value="10">черновик</option>
          <option value="20">открыта</option>
          <option value="25">выполняется</option>
          <option value="30">отменена</option>
          <option value="40">завершена</option>
        </select>
        <label class="block text-gray-700">Водитель:</label>
        <select v-model="form.driver" class="form-select mt-1 w-full">
          <option :value="null" />
          <option v-for="driver in drivers" :key="driver.id" :value="driver.id">{{ driver.first_name }} {{ driver.last_name }}</option>
        </select>
        <label class="block text-gray-700">Авто:</label>
        <select v-model="form.car" class="form-select mt-1 w-full">
          <option :value="null" />
          <option v-for="car in cars" :key="car.id" :value="car.id">{{ car.mark }} {{ car.model }} {{ car.color }} {{ car.grn }}</option>
        </select>
        <label class="block text-gray-700">Маршрут:</label>
        <select v-model="form.route" class="form-select mt-1 w-full">
          <option :value="null" />
          <option v-for="route in routes" :key="route.id" :value="route.id">{{ route.name }}</option>
        </select>
      </search-filter>
      <Link class="btn-indigo" :href="'/trips/?search=' + today">
        <span>Сегодня</span>
      </Link>
      <Link class="btn-indigo" :href="'/trips/?search=' + tomorrow">
        <span>Завтра</span>
      </Link>
      <Link class="btn-indigo" href="/trips/create">
        <span>Добавить</span>
        <span class="hidden md:inline">&nbsp;поездку</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">ID</th>
          <th class="pb-4 pt-6 px-6">Дата</th>
          <th class="pb-4 pt-6 px-6">Маршрут</th>
          <th class="pb-4 pt-6 px-6">Водитель</th>
          <th class="pb-4 pt-6 px-6">Авто</th>
          <th class="pb-4 pt-6 px-6">Места</th>
          <th class="pb-4 pt-6 px-6"><icon name="users" class="mr-2 w-4 h-4" /></th>
          <th class="pb-4 pt-6 px-6" colspan="2">Статус</th>
        </tr>
        <tr v-for="trip in trips.data" :key="trip.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/trips/${trip.id}/edit`">
              #{{ trip.id }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/trips/${trip.id}/edit`">
              {{ trip.trip_date }}
              <icon v-if="trip.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/trips/${trip.id}/edit`">
              {{ trip.route.name }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/trips/${trip.id}/edit`" tabindex="-1">
              {{ trip.driver.first_name }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/trips/${trip.id}/edit`" tabindex="-1">
              {{ trip.car.mark }} {{ trip.car.model }} {{ trip.car.color }} {{ trip.car.grn }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/trips/${trip.id}/edit`" tabindex="-1">
              {{ trip.available_seats }} <span v-if="trip.awaits_count > 0" style="color:red">&nbsp;!{{ trip.awaits_count }}</span>
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/trips/${trip.id}/edit`" tabindex="-1">
              {{ trip.clients_count }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/trips/${trip.id}/edit`" tabindex="-1">
              <span v-if="trip.status_id === 10" style="color: gray"> {{ trip.status_name }} </span>
              <span v-if="trip.status_id === 20" style="color: darkgreen"> {{ trip.status_name }} </span>
              <span v-if="trip.status_id === 25" style="color: darkgreen"> {{ trip.status_name }} </span>
              <span v-if="trip.status_id === 30" style="color: darkred"> {{ trip.status_name }} </span>
              <span v-if="trip.status_id >= 40"> {{ trip.status_name }} </span>
            </Link>
          </td>
          <td class="w-px border-t">
            <Link class="flex items-center px-4" :href="`/trips/${trip.id}/edit`" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
        </tr>
        <tr v-if="trips.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="4">Поездки не найдены</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="trips.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    trips: Object,
    drivers: Object,
    cars: Object,
    routes: Object,
    today: String,
    tomorrow: String,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        driver: this.filters.driver,
        car: this.filters.car,
        route: this.filters.route,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/trips', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
